<template>
  <div class="card wrapper">
      <h4>Instance Details</h4>
       <table class="striped" v-if="!loading">
        <thead>
          <tr>
              <th>S.No.</th>
              <th>Instance</th>
              <th>Data Version</th>
              <th>Data Package Size(in MB)</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(instance, index) in instances" :key="instance.name + '_' + index" :class="instance.background">
            <td>{{index + 1}}.</td>
            <td>{{instance.name}}</td>
            <td v-if="instance.loading">Fetching data...</td>
            <td v-else>{{instance.version}}</td>
            <td v-if="instance.loading">Fetching data...</td>
            <td v-else>{{instance.size}}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="loading" class="loading">Loading Data...</div>
  </div>
</template>

<script>
export default {
  name: "DataPackageSize",
  data() {
    return {
        instances:[],
        loading:true
    };
  },
  mounted() {
      this.instances = [];
      this.getInstances();
  },
  methods: {
    getInstances(){
        this.$http.get("/dialogs?tag=start").then(r => {
            if(r.data && r.data.length){
                r.data.forEach(instance => {
                    this.instances.push({"name":"start_" + instance.phrase, "size":null, "version":null, "loading":true})
                })
                this.instances.forEach((instance, index) => this.getInstanceDetails(instance.name, index));
            }
            this.loading = false;
        }).catch(() => {
            this.loading = false;
        })
    },
    getInstanceDetails(instance, index){
        this.$http.get("/settings/datapackagesize?instance=" + instance).then(r => {
            if(r.data.status){
                this.instances[index].version = r.data.data.version;
                this.instances[index].size = ((parseInt(r.data.data.file_size))/(1024 * 1024)).toFixed(2);
                this.instances[index].loading = false;
                this.setBackgroundColor(index, this.instances[index].size);
            }else{
                this.instances[index].version = "N/A";
                this.instances[index].size = "N/A";
                this.instances[index].loading = false;
            }
        }).catch(() => {
            this.instances[index].version = "N/A";
            this.instances[index].size = "N/A";
            this.instances[index].loading = false;
        })
    },
    setBackgroundColor(index, size){
        var bg = "border-bottom ";
        if(size < 10){
            bg += "green";
        }else if(size < 25){
            bg += "yellow";
        }else{
            bg += "red";
        }
        this.instances[index].background = bg;
    }
  },
};
</script>

<style scoped>
.wrapper{
    padding:10px;
}
.border-bottom{
    border-bottom:1px solid white;
}
.loading{
    font-size:24px;
    height:40vh;
    display: flex;
    align-items:center;
    justify-content:center;
}
</style>